import { render, staticRenderFns } from "./drawDetail.vue?vue&type=template&id=290a1591&scoped=true"
import script from "./drawDetail.vue?vue&type=script&lang=js"
export * from "./drawDetail.vue?vue&type=script&lang=js"
import style0 from "./drawDetail.vue?vue&type=style&index=0&id=290a1591&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290a1591",
  null
  
)

export default component.exports